import { Typography } from "@povio/ui";

interface IProps {
  section: string;
  actionButton?: React.ReactNode;
}

const ProfileNoSectionData = ({ section, actionButton }: IProps) => {
  return (
    <div className="flex flex-col items-center justify-center">
      <Typography
        variant="prominent-1"
        size="label-2"
        className="pt-6 pb-3 text-center text-text-default-3"
      >
        There is currently no data for {section}
      </Typography>
      {actionButton}
    </div>
  );
};

export default ProfileNoSectionData;
